import React from 'react';
import { CategoryPage } from '@depict-ai/react-ui';
import Link from 'redux-first-router-link';
import { connect } from 'react-redux';
import DepictItem from './DepictItem';
import Top from '../Top/Top';
import TemplateParserDeprecated from '../Templates/TemplateParserDeprecated';
import { listItemCache } from '../../actions/checkout';
import { toggleFavourite } from '../../actions/environment';
import { translate } from '../../utils/locale';
import s from './Category.scss';

const Category = ({ setup, categoryData, depictListings, favourites, productCache, data = {}, currentPath = '', listingId = false, stateKey = false, layout = false, ...props }) => {
	const depictListing = depictListings[setup.language];
	const specificSections = data?.content?.section;
	const pathParts = currentPath.split('/');
	const extraInfo = {};

	const matchDeepLink = (obj = {}, i, length) => {
		const matchingId = Object.keys(obj)
			.filter((dL) => (
				pageType === obj[dL].listing_type
				&& obj[dL].slug === pathParts[i - 1]
			))[0];

		if (!matchingId) return obj;
		if (i < length && obj[matchingId].children) {
			const nextI = i + 1;
			return matchDeepLink(obj[matchingId].children, nextI, length);
		}
		return obj[matchingId];
	};

	const findExternalId = (obj = {}, centraId) => {
		const matchingIds = Array.isArray(obj) ? obj : Object.keys(obj)
			.filter((dL) => (
				pageType === obj[dL].listing_type
			))
			.map((dL) => obj[dL]);

		for (let i = 0; i < matchingIds.length; i += 1) {
			if (matchingIds[i].external_id === centraId) {
				return matchingIds[i];
			}

			if (matchingIds[i].children && matchingIds[i].children.length > 0) {
				const result = findExternalId(matchingIds[i].children, centraId);
				if (result) return result;
			}
		}

		return false;
	};

	let pageType = 'category';
	if (data.baseType === 'brands') pageType = 'brand';

	let listingObj = {};

	if (listingId) {
		listingObj.listing_id = listingId;
		pageType = 'smart_pick';
	} else if (pageType === 'brand') {
		const pageTitle = translate(setup, (data?.brand?.title || data.content.title));

		listingObj = Object.keys(depictListing)
			.filter((dL) => (
				pageType === depictListing[dL].listing_type
				&& depictListing[dL].title === pageTitle
			)).map((dL) => depictListing[dL])[0];

		extraInfo.showBreadcrumbs = false;
	} else {
		listingObj = matchDeepLink(depictListing, 1, pathParts.length);
		if (!listingObj || Array.isArray(listingObj)) {
			const centraId = categoryData?.[setup.language]?.[currentPath] || false;
			if (centraId) listingObj = findExternalId(depictListing, String(centraId));
		}
	}

	if (layout) extraInfo.layout = layout;
	if (stateKey) extraInfo.stateKey = stateKey;

	return (
		<main className={[s.category, listingId ? s.category__embed : null].join(' ')} role="main">
			{ data.content && <Top setup={setup} pageContent={data.content} paths={data.paths} /> }
			{ specificSections && specificSections.length > 0 && <TemplateParserDeprecated sections={specificSections} setup={setup} /> }
			{/* eslint-disable react/jsx-indent-props */}
			{
				listingObj?.listing_id && (
					<CategoryPage
						listingQuery={{ type: 'listingId', id: listingObj.listing_id }}
						{...extraInfo}
						showQuicklinks={false}
						gridSpacing="12px"
						productCard={(ps) => (
							<DepictItem {...ps} setup={setup} Link={Link} listItemCache={props.listItemCache} favourites={favourites} toggleFavourite={props.toggleFavourite} currentView={currentPath} isCategory={pageType === 'category' || pageType === 'brand'} />
						)}
					/>
				)
			}
			{/* eslint-enable react/jsx-indent-props */}
		</main>
	);
};

const mapState = ({ environment, productCache }, props) => ({
	setup: environment.setup,
	categoryData: environment?.categoryData,
	depictListings: environment?.depict,
	favourites: environment.favourites,
	productCache,
	...props,
});

export default connect(mapState, { toggleFavourite, listItemCache })(Category);
